import React, {Fragment, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Button, Container, Header, Image} from "semantic-ui-react";
import TinySlider from "tiny-slider-react";

import {APP} from '../../../constants';
import {fetchPosts} from "../../../redux/actions";
import {FormattedMessage} from "react-intl";

const subdomain = window.location.host.split('.')[0];

export const Posts = ({city, city_id, from}) => {

    const [posts, setPosts] = useState([]);

    const city_url = `/${from}/${city_id}/${city.slug}`;

    useEffect(() => {

        const fetchData = async () => {

            try {

                // get posts
                const result = await fetchPosts(city_id, 0, 0, from, 1);

                // set posts
                setPosts(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [city_id]);

    const settings = {
        lazyload: true,
        nav: true,
        navPosition: 'bottom',
        controls: false,
        mouseDrag: true,
        controlsText: ["<", ">"],
        loop: true,
        items: 1,
        gutter: 20,
        responsive: {
            420: {
                items: 1
            },
            960: {
                items: 3
            }
        }
    };

    if (posts.length === 0) {

        return (
            <Fragment/>
        );
    }

    return (
        <Container as="section" className="section-events posts">
            <Header as="h2">
                {
                    from === 'city'
                        ? <FormattedMessage id="A Cidade"/>
                        : <FormattedMessage id={["europa", "italia"].includes(subdomain)? "Famílias" : "Cult In Minas"}/>
                }
            </Header>
            <div
                style={{
                    width: "100%",
                    position: "relative"
                }}
            >
                <TinySlider settings={settings}>
                    {
                        posts.map((event) => {

                            const {id, title, body, slug, category_id, image} = event;
                            let text = body ? body.replace(/<[^>]+>/g, '').substr(0, 165)+"... " : "";
                            let imagex = APP.images.posts.path + image.replace('big', 'small');

                            return (
                                <Link to={`${city_url}/read/${id}/${slug}?category=${category_id}`} key={`event-${id}`}>
                                    <div style={{position: "relative"}}>
                                        <Image src={imagex}/>
                                        {/*{*/}
                                        {/*    from !== "columnists" &&*/}
                                        {/*        <div className="content">*/}
                                        {/*            <Header as="h3" className={'no-bar'}>{title}</Header>*/}
                                        {/*        </div>*/}
                                        {/*}*/}
                                    </div>
                                    {/*{*/}
                                    {/*    from === "columnists" && <>*/}
                                            <Header
                                                as="h3" className={'no-bar'}
                                                style={{
                                                    marginBottom: 8
                                                }}
                                            >{title}</Header>
                                            <p
                                                className={"excerpt"}
                                            >
                                            <span
                                                dangerouslySetInnerHTML={{__html: text}}
                                                style={{
                                                    color: '#000'
                                                }}
                                            />
                                            [<FormattedMessage id="leia mais"/>]
                                            </p>
                                    {/*    </>*/}
                                    {/*}*/}
                                </Link>
                            )
                        })
                    }
                </TinySlider>
            </div>
            <Link to={`${city_url}/home/0/0`}>
                <Button color="orange" size="big">
                    <FormattedMessage id="Ver todos"/>
                </Button>
            </Link>
        </Container>
    );
};
